import { Lock } from "lucide-react";

/**
 * Sits above the rules, submission types and review categories tables for a reader who
 * cannot change them, so the limit is known before anything is tried.
 */
const PlanReviewReadOnlyNotice = () => (
	<div className="prron-notice">
		<Lock size={16} className="prron-notice-icon" />
		<p className="prron-notice-text">
			You have view-only access. Only managers from your organization can change these settings.
		</p>
	</div>
);

export default PlanReviewReadOnlyNotice;
